import { Injectable, ApplicationRef } from '@angular/core';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import {  merge, fromEvent, throttleTime } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
    checking = false;

    constructor(
        private swUpdate: SwUpdate,
        private appRef: ApplicationRef,
    ) {}

    initRefreshApp() {
        if (!this.swUpdate.isEnabled) {
            console.log('Service Worker non activé');
            return;
        }

        const appReturnedToForeground$ = fromEvent(document, 'visibilitychange').pipe(
            filter(() => document.visibilityState === 'visible')
        );
        const isOnline$ = fromEvent(window, 'online');
        const isClick$ = fromEvent(document, 'click').pipe(throttleTime(5 * 60 * 1000));

        merge(
            appReturnedToForeground$,
            isOnline$,
            isClick$,
        ).subscribe(() => {
            this.checkForUpdates();
        });

        this.initUpdateListener();
    }

    private async checkForUpdates() {
        if (this.checking) return;
        this.checking = true;

        try {
            const hasUpdate = await this.swUpdate.checkForUpdate();
            if (hasUpdate) console.log('Nouvelle version détectée');
        } catch (err) {
            console.error('Erreur checkForUpdate', err);
        } finally {
            this.checking = false;
        }
    }

    private initUpdateListener() {
        this.swUpdate.versionUpdates.subscribe((event: VersionEvent) => {
            switch (event.type) {
                case 'VERSION_DETECTED':
                    console.log(`Téléchargement de la nouvelle version : ${event.version.hash}`);
                    break;
                case 'VERSION_READY':
                    console.log(`Nouvelle version prête : ${event.latestVersion.hash}`);
                    this.refreshApp();
                    break;
                case 'VERSION_INSTALLATION_FAILED':
                    console.error(`Erreur d'installation : ${event.error}`);
                    break;
            }
        });
    }

    private refreshApp() {
        this.swUpdate.activateUpdate().then(() => window.location.reload());
    }
}
